export default __webpack_public_path__ + "static/media/website.38876a6d.png";